module.exports = __webpack_public_path__ + "img/changes-credential.50bb5903.svg";